const GENERAL_DCF = {
  annonceur: 'Ann. : {nbAnnonceur}',
  lineType: {
    normal: 'vente divers',
    regroupement: 'vente produit patrimonial',
    sousTotal: 'sous total',
    remise: 'remise',
    commentaire: 'commentaire',
    personnalise: 'vente personnalisée',
    location: 'vente de location',
  },
  calculette: {
    actions: {
      calculette: 'Calculette',
    },
    title: 'Calculette - {libelleLigne}',
    sousTitle: 'Sélectionner les produits à ajouter au calcul',
    pourcentage: 'Pourcentage',
    messages: {
      success: {
        editPrixUnitaire: 'Prix unitaire de la ligne modifié avec succès.',
      },
    },
  },
  suiviMensuel: {
    totalMntBrouillonTlpe: 'Total TLPE brouillon',
    totalMntBrouillonHorsTlpe: 'Total HT brouillon hors TLPE',
    totalMntFactureTlpe: 'Total TLPE facturé',
    totalMntFactureHorsTlpe: 'Total HT facturé hors TLPE',
    totalMntAFacture: 'Total HT à facturer',
    nonCalcule: 'Non calculé',
    nonCalculeTooltip: 'La période est trop grande pour calculer le montant',
  },
  messages: {
    errors: {
      remiseNetFace: 'Impossible d\'obtenir un prix net face sur des lignes de ventes avec des produits qui ne sont pas des réseaux temporaire',
      prixNetFaceSouhaiteNull: 'Impossible d\'obtenir un prix net face sans prix net face souhaitée',
      remisePrixDepartZero: 'Impossible d\'ajouter une remise avec un prix de départ à 0',
      propertyTriNull: 'Impossible de faire le tri ! Veuillez renseigner tous les champs.',
      duplicatePossibility: 'Impossible de faire la duplication !',
    },
  },
  remise: {
    netFace: {
      title: 'Je cherche à obtenir un prix net face',
      libelle: 'Libellé remise',
      prixNet: 'Prix net face souhaité',
    },
  },
  trierLignes: 'Trier sur toutes les lignes',
  triLignes: {
    title: 'Tri de lignes',
    selectProperty: 'Sélectionner une propriété',
    msgInfo: 'Le tri va s\'effectuer sur toutes les lignes',
    triPossibles: {
      libelle: 'Libellé',
      startdate: 'Date de départ',
      product: 'Produit',
    },
    sensTri: {
      title: 'Sélectionner un sens de tri',
      ascendant: 'Ascendant',
      descendant: 'Descendant',
    },
  },
};

export default GENERAL_DCF;
